module.exports = __webpack_public_path__ + "static/media/CTA-SIMULADO.e5d3d010.png";